/**
 * /ninety — My Day · Summary tab.
 *
 * VISUAL REFERENCE build for the development team: reads the fake in-memory
 * store in ~/components/myday/store.ts (no Supabase). Shows today's schedule
 * with a toggle to preview the empty state.
 */
import { createFileRoute } from '@tanstack/react-router';
import { TodaySchedule } from '~/components/myday/summary/TodaySchedule';
import { FakeDataNote } from '~/components/myday/ui';

export const Route = createFileRoute('/_app/ninety/')({
  component: SummaryTab,
});

function SummaryTab() {
  return (
    <div className="px-4 sm:px-6 py-4">
      <TodaySchedule />
      <FakeDataNote />
    </div>
  );
}
